export default __webpack_public_path__ + "static/media/Wicked Heart.e50d4ffa.jpg";